import { ALL_TRANSACTION_STATUSES } from "gastos-shared";
import { PAYMENT_METHODS, TRANSACTION_STATUSES } from "./constants";

export const getPaymentMethodName = (paymentMethod: string) => {
  const method = PAYMENT_METHODS()?.find?.(({ id }) => id === paymentMethod);

  return method?.name || "";
};

export const paymentMethod = {
  getById: (paymentMethodId: string) => {
    return PAYMENT_METHODS()?.find?.(({ id }) => id === paymentMethodId);
  },
  getNameById: (paymentMethodId: string) => {
    const status = paymentMethod.getById(paymentMethodId);

    return status?.name;
  },
};

export const transactionStatus = {
  getById: (statusId: string) => {
    return TRANSACTION_STATUSES()?.find?.(({ id }) => id === statusId);
  },
  getNameById: (statusId: string) => {
    const status = transactionStatus.getById(statusId);

    return status?.name;
  },
  getIdByName: (statusName: string) => {
    const status = TRANSACTION_STATUSES()?.find?.(
      ({ name }) => name === statusName
    );

    return status?.id;
  },
  isPaid: (statusId: string) => {
    return statusId === ALL_TRANSACTION_STATUSES.PAID;
  },
  isPending: (statusId: string) => {
    return statusId === ALL_TRANSACTION_STATUSES.PENDING;
  },
  isVoid: (statusId: string) => {
    return statusId === ALL_TRANSACTION_STATUSES.VOID;
  },
};
